// extracted by mini-css-extract-plugin
export default {"toggle":"select_toggle__egX52","dropdown":"select_dropdown__TbsFI"};